import useIsWeb from "./useIsWeb";

const useIsMobile = () => {
    return !useIsWeb();
};

export default useIsMobile;
